module.exports = __webpack_public_path__ + "static/media/google-drive.25e8561a.png";